import { useAuth } from '../../../auth/auth-context'
import useFetch from '../../../_fetch'
import { getColumns } from './columns'
import { Table } from '../_table/table'

export default function ClickReport() {
    const {user} = useAuth()
    const { doFetch } = useFetch()
    const isPublisher = user?.kind === 'publisher'
    const columns = getColumns(isPublisher)
    
  return (
    <Table 
        columns={columns} 
        getData={async (fromDate, toDate) => {
            const res = await doFetch('/data/get-clicks', {
                fromDate, toDate, timezoneOffsetMinutes: new Date().getTimezoneOffset()
            })
            if (!res.ok) throw new Error('Clicks could not be fetched for the selected period.')

            const data = await res.json()
            if (!Array.isArray(data)) throw new Error('The server returned an unexpected click report format.')

            return data
        }}
        title='Click Report'
        description='Analyze daily click volume by network, country, campaign, and publisher.'
        entityLabel='click records'
        pageKey='click-report'
        defaultSort='date'
    />)
}
